import { CSSProperties } from "@material-ui/core/styles/withStyles";

// styles
import { greys } from "@clockwise/web-commons/src/styles/color.styles";
import { fontFamily } from "@clockwise/web-commons/src/styles/type.styles";
import {
  header,
  body,
} from "@clockwise/web-commons/src/components/tutorial-tip/TutorialTip.styles";

export const assistantContainer: CSSProperties = {
  position: "relative",
  overflowY: "auto",
  width: 300,
  padding: "0 4px 0 6px",
  background: greys.paleGrey,
  borderLeft: `1px solid ${greys.borderGrey}`,
};

export const eventContainer: CSSProperties = {
  overflowY: "auto",
  width: 600,
  minHeight: 400,
  maxHeight: "80vh",

  "& .relative-wrapper": {
    position: "relative",
  },

  "& .icon-button": {
    backgroundColor: greys.white,
    position: "absolute",
    top: 8,
    right: 8,
  },
};

export const calendarContainer: CSSProperties = {
  flex: 1,
  overflowY: "auto",
};

export const calendarContainerWrapper: CSSProperties = {
  flex: 1,
  display: "flex",
  flexDirection: "column",

  "@media (max-width: 768px)": {
    display: "none",
  },
};

export const select: CSSProperties = {
  fontFamily,
  color: greys.slate,
  fontSize: "16px",
  lineHeight: "16px",
  fontWeight: "bold",
  marginLeft: 12,
};

export const wrapperContainer: CSSProperties = {
  position: "relative",
  flex: 1,
  display: "flex",
  flexDirection: "row",
  width: "100%",
  height: "100%",
  "@media (max-width: 768px)": {
    minWidth: "unset",
  },
};

export const legend: CSSProperties = {
  background: greys.white,
  border: `1px solid ${greys.borderGrey}`,
  borderLeft: 0,
  display: "flex",
  flexDirection: "row",
  width: 225,
  paddingLeft: 12,
  position: "absolute",
  left: 0,
  top: 0,
  zIndex: 30,
  borderRadius: "0 0 8px 0",
  transition: "transform 250ms",
  "& .form": {
    flex: 1,
  },
  "& .toggle": {
    display: "flex",
    justifyContent: "center",
    cursor: "pointer",
    position: "absolute",
    left: "calc(100% - 1px)",
    background: greys.white,
    border: `1px solid ${greys.borderGrey}`,
    borderLeft: 0,
    borderRadius: "0 8px 8px 0",
    top: -1,
  },
};

export const styles = {
  tipHeader: header,
  tipBody: body,
  assistantContainer,
  eventContainer,
  calendarContainer,
  calendarContainerWrapper,
  select,
  wrapperContainer,
  legend,
};
